export { Router } from "@baseline/web/routing/legacy/router";

// import * as routing from "@baseline/web/routing/legacy";
// import { Context } from "@baseline/web/routing/legacy/context";
// import { Request } from "./request";
// import { Route } from "./route";


// export class Router extends routing.Router
// {
//     constructor(routes: Route[])
//     {
//         super(routes);
//         this.route = this.route.bind(this);
//     }

//     route(context: Context): Promise<boolean>;
//     route(path: string): Promise<boolean>;
//     route(arg: string | Context): Promise<boolean>;
//     override async route(arg: string | Context): Promise<boolean>
//     {
//         const context =
//             (typeof arg == "string")
//                 ? createContext(arg)
//                 : arg;

//         return super.route(context);
//     };


//     override readonly routes: Route[];
// }


// function createContext(path: string): Context
// {
//     const segments = path.split('/').filter(segment => !!segment);
//     const requestPath = segments.join('/');
//     const request: Request = { path, segments, requestPath, requestSegments: segments };
//     const context = { request };
//     return context;
// }
